export var CREATE_PROSPECT_REQUEST = 'CREATE_PROSPECT_REQUEST';
export var CREATE_PROSPECT_SUCCESS = 'CREATE_PROSPECT_SUCCESS';
export var CREATE_PROSPECT_FAIL = 'CREATE_PROSPECT_FAIL';
export var CONFIRM_PROSPECT_REQUEST = 'CONFIRM_PROSPECT_REQUEST';
export var CONFIRM_PROSPECT_SUCCESS = 'CONFIRM_PROSPECT_SUCCESS';
export var CONFIRM_PROSPECT_FAIL = 'CONFIRM_PROSPECT_FAIL';
export var CLEAR_PROSPECT_ERRORS = 'CLEAR_PROSPECT_ERRORS';
export var SET_PROSPECT_INFO = 'SET_PROSPECT_INFO';
export var CLEAR_PROSPECT_INFO = 'CLEAR_PROSPECT_INFO';
export var CLEAR_PROSPECT_DATA = 'CLEAR_PROSPECT_DATA';